import { useEffect, useState } from 'react';
import { api, errorText } from '../api';
import { Card, Loading, Notice } from '../components/ui';
import type { Frist } from '../types';

const ART_LABEL: Record<string, string> = { ticket: 'Tickets', bestellung: 'Bestellungen', service: 'Werkstatt' };

export function FristenPage() {
  const [fristen, setFristen] = useState<Frist[] | null>(null);
  const [meldung, setMeldung] = useState<{ art: 'error' | 'success'; text: string } | null>(null);

  useEffect(() => {
    void api<Frist[]>('/api/einstellungen/fristen').then(setFristen);
  }, []);

  const aendere = (i: number, feld: 'frist_stunden' | 'eskalation_stunden', wert: string) =>
    setFristen((alt) => alt!.map((f, j) => (j === i ? { ...f, [feld]: Number(wert) } : f)));

  async function speichern() {
    try {
      await api('/api/einstellungen/fristen', { method: 'PUT', body: fristen });
      setMeldung({ art: 'success', text: 'Fristen gespeichert. Sie gelten für neu angelegte Tickets.' });
    } catch (e) {
      setMeldung({ art: 'error', text: errorText(e) });
    }
  }

  if (!fristen) return <Loading />;
  const arten = [...new Set(fristen.map((f) => f.vorgang_art))];

  return (
    <>
      <div className="kopf">
        <h1>Status &amp; Fristen</h1>
        <span className="spacer" />
        <button className="primary" onClick={() => void speichern()}>
          Speichern
        </button>
      </div>
      {meldung && <Notice kind={meldung.art}>{meldung.text}</Notice>}
      <p className="muted" style={{ marginTop: 0 }}>
        <strong>Frist</strong>: so lange hat der Zuständige ab Anlage Zeit. <strong>Eskalation</strong>: so lange nach Ablauf der Frist geht
        eine Sammelmail an die Eskalationsempfänger. 0 heißt: sofort bei Fristablauf.
      </p>
      <div className="stack">
      {arten.map((art) => (
        <Card key={art} title={ART_LABEL[art] ?? art} padded={false}>
          <table>
            <thead>
              <tr>
                <th>Status / Art</th>
                <th>Was zu tun ist</th>
                <th style={{ width: 160 }}>Frist (Std.)</th>
                <th style={{ width: 200 }}>Eskalation nach (Std.)</th>
              </tr>
            </thead>
            <tbody>
              {fristen.map((f, i) =>
                f.vorgang_art !== art ? null : (
                  <tr key={f.status}>
                    <td>{f.bezeichnung}</td>
                    <td className="muted">{f.aufgabe ?? '—'}</td>
                    <td>
                      <input type="number" min={1} value={f.frist_stunden} onChange={(e) => aendere(i, 'frist_stunden', e.target.value)} />
                    </td>
                    <td>
                      <input type="number" min={0} value={f.eskalation_stunden} onChange={(e) => aendere(i, 'eskalation_stunden', e.target.value)} />
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </Card>
      ))}
      </div>
      <p className="small muted">Fristen für Lieferungen und Außendienst kommen mit Phase 3 hinzu. Geänderte Fristen gelten ab dem nächsten Statuswechsel.</p>
    </>
  );
}
